/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { SubscriptionResumePathParams, SubscriptionResumeResponse } from '../types/SubscriptionResume'

/**
 * POST /:organisation/profiles/:profile/subscription/resume
 * @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::resume
 */
export async function subscriptionResume(
	organisation: SubscriptionResumePathParams['organisation'],
	profile: SubscriptionResumePathParams['profile'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<SubscriptionResumeResponse>> {
	return axiosInstance.post(`/${organisation}/profiles/${profile}/subscription/resume`, undefined, config)
}
